import MenuContent from './MenuContent'
import MenuBtn from './MenuBtn'

const NavMenu = props => {

    const menu = [
        {
            key: '/',
            label: '关于我们'
        },
        // {
        //     key: '/',
        //     label: '最新动态'
        // },
        // {
        //     key: '/',
        //     label: '我们的产品'
        // },
        // {
        //     key: '/',
        //     label: '加入我们'
        // },
    ]

    const handleOnClickMenu = e => {
        const { url } = e.target.dataset
        if (url) window.location.href = url
    }

    return <div className="menu">
        <MenuContent menu={menu} onClick={handleOnClickMenu} />
        <MenuBtn menu={menu} onClick={handleOnClickMenu} />
    </div>
}

export default NavMenu 
